import { RepositoryFabric } from "@api/repositories/RepositoryFabric";
import { StaticConfigRepository } from "@api/repositories/StaticConfigRepository";

export class AppVersionChecker {

    counter?: NodeJS.Timeout;
    constructor(private repositories: RepositoryFabric) {}

    /**
     * every 60 seconds checks the current version of the application
     * and if the version differs from the loaded one then the page is reloaded
     */
    watch(): void {

        const staticRepository: StaticConfigRepository = this.repositories.get(RepositoryFabric.STATIC);

        const script = ([...document.getElementsByTagName("script")] || []).find(item => item.src.indexOf("js/app.") >= 0);

        if (script) {
            const splitedUrl = script.src.split(".");
            let version = splitedUrl[splitedUrl.length - 2]
            if (version) {
                this.counter = setInterval(() => {
                    staticRepository.get("version")
                        .then(res => {
                            if (res && res.trim() != version) {
                                window.location.reload();
                            }
                        })
                        .catch(e => { console.error(e) });
                }, 3 * 60000);
            }
        }
    }

    /**
     * stop watching app version
     */
    stopWatching(): void {
        if (this.counter) {
            clearInterval(this.counter);
        }
    }
}